import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigation, useLocalStorage } from '~/Hooks';
import { Route } from '~/Constants/Routes.constants';
import { FailOutlineCircle } from '~/Components/Icons/FailOutlineCircle';
import { ICON_ERROR } from '~/Constants/Colors.constants';
import { Link, Button, Typography } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(() => ({
  onboardingConfirmationContent: {
    textAlign: 'center',
    maxWidth: 552,
    padding: '0 20px',
    margin: 'auto',
  },
  onboardingColumn: {
    overflowY: 'auto',
    flex: 1,
  },
  onboardingConfirmationTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    lineHeight: '27px',
    overflowWrap: 'break-word',
    margin: '0 auto 30px',
  },
  onboardingConfirmationDesc: {
    fontSize: 16,
    marginBottom: 30,
    lineHeight: '27px',
    margin: '0 auto 30px',
    maxWidth: 310,
  },
  onboardingConfirmationConfirmButton: {
    width: 300,
    height: 50,
    fontSize: '1rem',
  },
  failedIcon: {
    width: 50,
    height: 50,
    color: ICON_ERROR,
    marginBottom: 30,
  },
}));

export const OnboardingConfirmationFailed = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const { logout } = useLocalStorage();

  const goToLogin = () => {
    logout();
    navigate(Route.LOGIN);
  };

  return (
    <React.Fragment>
      <div className={classes.onboardingColumn}>
        <div className={classes.onboardingConfirmationContent}>
          <FailOutlineCircle className={classes.failedIcon} />
          <Typography className={classes.onboardingConfirmationTitle}>
            {t('onboarding.email.verification.failed')}
          </Typography>
          <Typography className={classes.onboardingConfirmationDesc}>
            <Trans
              i18nKey="onboarding.email.verification.failedMessage"
              components={[<Link key="support" href="mailto:support@fitogram.de" />]}
            />
          </Typography>

          <Button
            className={classes.onboardingConfirmationConfirmButton}
            onClick={goToLogin}
            variant="contained"
            color="primary"
          >
            {t('app.continue')}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};
